import React, { useEffect, useState, useMemo, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import {
  Panel,
  PanelHeader,
  PanelBody,
  useFilters,
} from "../../components/panel/panel.jsx";
import Highlight from "react-highlight";
import DataTable from "react-data-table-component";
import { useNavigate, useLocation } from "react-router-dom";
import { myContactsActions, authActions } from "../../_store/index.js";
import { isDateSpansEqual } from "@fullcalendar/core/internal";
import ReactToPrint from "react-to-print";
import { useReactToPrint } from "react-to-print";
import Table from "../../components/common/Table.jsx";
import generatePDF from "../../components/common/pdf/generatePDF.js";
import DatePickerComponent from "../../components/common/UI/Inputs/InputControls/DateInput.jsx";
import purchaseHistoryschema from "../../validation/purchaseHistoryschema.js";
import TableForPurchaseHistory from "./TableForPurchaseHistory.jsx";
import useFullPageLoader from "../../hooks/useFullPageLoader";
import translations from "../../config/TranslateFile.jsx";
import { CreateEventLogTextFileForInbox, EventLog } from "../../components/common/EventLog/EventLog.jsx";
import { storeCurrentRoute } from "../../utils/routeTracker.js";
import { getStoredValue } from "../../_helpers/storagehelper.js";

const PurchaseHistory = () => {
  let navigate = useNavigate();
  const dispatch = useDispatch();
  const {
    PublicInmateConnectionResponse,
    LoadPublicMyContactsDisplay,
    LoadCreditDebitTransactionDetails,
  } = useSelector((state) => state.myContacts);
  const PublicUser = useSelector((x) => x.auth.user);
  const componentRef = useRef(); // Ref used for print - Purchase History Table Current Row.
  const componentPrintTableRef = useRef(); // Ref used for print - Purchase History entire table.
  const location = useLocation();
  const currentLang = translations();
  const [transformedData, setTransformedData] = useState([]);
  const [isloading, setIsLoading] = useState(false);
  // State for Purchase History Popup - Download option (Entire Table)
  const [purchaseHistoryPopup, setPurchaseHistoryPopup] = useState({
    printOption: "1",
    fromDate: "",
    toDate: "",
    showLoadData: false,
    showMessage: false,
    filterData: [],
  });
  const [loader, showLoader, hideLoader] = useFullPageLoader();
  // State for Purchase History popup - Print Option (Entire Table)
  const [printOption, setPrintOption] = useState({
    PublicUserName: "",
    InmateFullName: "",
    InmateID: "",
    date: "",
    tableData: [],
  });
  const UserId = getStoredValue("userID");
  const PUIConnectionID = getStoredValue("puiConnectionID");
  const InmateName = getStoredValue("PurchaseHistoryInmateName");
  const [errors, setErrors] = useState({});
  const [IsHasData, setIsHasData] = useState(false);
  //  const editOrderID = location.state ? location.state.OrderID : 0;


  const SendCreditStatus = (status, row) => {
    const statusClasses = {
      1: "StatusPending",
      2: "StatusSent",
      3: 'StatusPatch-danger',
    };
    return <span className={status == "0.00" ? "status-zero" : statusClasses[row?.TransactionStatus] ? statusClasses[row?.TransactionStatus] : "StatusSent"}>{status == "0.00" ? "-" : status}</span>;
  };


  const SendDebitStatus = (status) => {
    return <span className={status == "0.00" ? "status-zero" : "StatusPatch-danger"}>{status == "0.00" ? "-" : status}</span>;
  };

  const columns = [
    {
      name: currentLang?.Amount,
      selector: (row) =>
        row.CurrentBalance !== 0
          ? row.CurrentBalance.toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 })
          : "0.00",
      sortable: true,
    },
    {
      name: currentLang?.OrderID,
      selector: (row) => (row.POTransactionRandomID !== 0 ? row.POTransactionRandomID : "-"),
      sortable: true,
    },
    {
      name: currentLang?.Credit,
      selector: (row) =>
        row.CreditAmount !== 0
          ? row.CreditAmount.toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 })
          : "0.00",
      sortable: true,
      cell: (row) => (
        <div className="d-flex "  >
          {SendCreditStatus((row.CreditAmount !== 0
            ? row.CreditAmount.toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 })
            : "0.00"), row)}
        </div>
      ),
    },
    {
      name: currentLang?.Debit,
      selector: (row) =>
        row.DebitAmount !== 0
          ? row.DebitAmount.toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 })
          : "0.00",
      cell: (row) => (
        <div className="d-flex "  >
          {SendDebitStatus(row.DebitAmount !== 0
            ? row.DebitAmount.toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 })
            : "0.00")}
        </div>
      ),
      sortable: true,
    },
    {
      name: currentLang?.Purpose,
      selector: (row) => row.TransactionPurpose,
      sortable: true,
    },
    { name: currentLang?.Date, selector: (row) => row.TransactionDate, sortable: true },
    {
      name: currentLang?.Action,
      sortable: true,
      cell: (row) => {
        return (
          <>
            <div
              className="btn btn-primary shadow btn-xs sharp me-1"
              title={currentLang?.Mycontacts?.Purchase_History}
              onClick={() => handlePrintShow(row)}
            >
              <i class="fa-solid fa-print"></i>
            </div>
          </>
        );
      },
    },
  ];

  const handlecreditDebitstatus = (LoadCreditDebitTransactionDetails) => {
    if (LoadCreditDebitTransactionDetails != undefined) {
      if (LoadCreditDebitTransactionDetails.length > 0) {
        setIsHasData(true);
      }
      else {
        setIsHasData(false);
      }
      // Transform the data by picking the necessary fields and adding status logic
      const newData = LoadCreditDebitTransactionDetails.map((row) => {
        return {
          CurrentBalance: row.CurrentBalance !== 0
            ? row.CurrentBalance.toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 })
            : "0.00",
          POTransactionRandomID: (row.POTransactionRandomID !== 0 ? row.POTransactionRandomID : "-"),
          CreditAmount: row.CreditAmount !== 0
            ? row.CreditAmount.toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 })
            : "0.00",
          DebitAmount: row.DebitAmount !== 0
            ? row.DebitAmount.toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 })
            : "0.00",
          CreditBalance: row.CreditBalance !== 0 && row.CreditBalance !== undefined
            ? row.CreditBalance.toLocaleString("en-US", {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            })
            : "0.00",
          TransactionPurpose: row.TransactionPurpose,
          TransactionDate: row.TransactionDate,
          InmateID: row.InmateID,
          InmateResidentId: row.InmateResidentId,
          InmateFullName: row.InmateFullName,
          PublicUserName: row.PublicUserName,
          TransactionStatus: row?.TransactionStatus
        };
      });

      // Set the transformed data to state
      setTransformedData(newData);
      hideLoader(); setIsLoading(false);
    }
  }


  const handleChanges = () => {
    const infoMessage = "Purchase History page Redirected into My contacts Page (Click Back button)";
    const redirectURL = "public/Mycontacts";
    const Status = "---";
    const Response = "---";
    EventLog(dispatch, infoMessage, redirectURL, Response, Status);
    navigate("/public/Mycontacts");
    storeCurrentRoute("/public/Mycontacts");
  };

  useEffect(() => {
    const data = {
      purchaseOrderId: 0,
      userID: UserId,
      inmatesId: 0,
      puiConnectionID: PUIConnectionID,
      facilityID: 0,
      fromDate: "",
      toDate: "",
      sortField: "TransactionDate DESC",
    };
    showLoader(); setIsLoading(true);
    dispatch(myContactsActions.LoadCreditDebitTransactionDetails(data)).then((x) => {
      const infoMessage = "My Contacts page - Redirected into Purchase History Page";
      const redirectURL = "public/PurchaseHistory";
      const Status = "Bind Purchase History to the Inmate ID - " + data?.inmatesId;
      const Response = JSON.stringify(x?.payload);
      EventLog(dispatch, infoMessage, redirectURL, Response, Status);
      handlecreditDebitstatus(x?.payload);
    });

  }, [dispatch]);

  // Filter Data Based on Search

  // const [filteredData, setFilteredData] = useState();
  const [isPrintData, setisPrintData] = useState(false);
  const [isPrintTable, setisPrintTable] = useState(false);
  const [ColumnOrderdata, setColumnOrderData] = useState(Date);

  const col = useMemo(() => columns, []);

  // Print function for Purchase history entire table
  const handlePrintTable = () => {
    let data = LoadCreditDebitTransactionDetails;

    if (purchaseHistoryPopup.printOption === "1") {
      const infoMessage = "Purchase History popup - All option - Clicked Print button";
      const Response = data?.length > 0 ? JSON.stringify(data) : "No data found";
      const Status = "Download Purchase History to the Inmate ID - " + data[0]?.InmateResidentId;
      const redirectURL = "---";
      EventLog(dispatch, infoMessage, redirectURL, Response, Status);
      setPrintOption({
        PublicUserName: data[0]?.PublicUserName || "N/A",
        InmateFullName: data[0]?.InmateFullName || "N/A",
        InmateID: data[0]?.InmateResidentId || "N/A",
        date: "",
        tableData: data,
      });
    } else if (purchaseHistoryPopup.printOption === "2") {
      const fromDate = new Date(purchaseHistoryPopup.fromDate);
      const toDate = new Date(purchaseHistoryPopup.toDate);

      const filteredData = data.filter((transaction) => {
        const transactionDate = new Date(transaction.TransactionDate);
        toDate.setHours(23, 59, 59, 999);
        return transactionDate >= fromDate && transactionDate <= toDate;
      });
      const infoMessage = `Purchase History popup - Range option - Clicked Print button (${fromDate} to ${toDate})`;
      const Response = filteredData?.length > 0 ? JSON.stringify(filteredData) : "No data found";
      const Status = "Print Purchase History to the Inmate ID - " + filteredData[0]?.InmateResidentId;
      const redirectURL = "---";
      EventLog(dispatch, infoMessage, redirectURL, Response, Status);
      if (!filteredData || filteredData.length === 0) {
        alert("No data found for the selected date range.");
        return;
      }
      setPrintOption({
        PublicUserName: filteredData[0]?.PublicUserName || "N/A",
        InmateFullName: filteredData[0]?.InmateFullName || "N/A",
        InmateID: filteredData[0]?.InmateResidentId || "N/A",
        date: `${purchaseHistoryPopup.fromDate} - ${purchaseHistoryPopup.toDate}`,
        tableData: filteredData,
      });
    }

    setTimeout(() => {
      setisPrintTable(true);
    }, 100);
  };

  useEffect(() => {
    if (isPrintTable) {
      handlePrintsTable();
      setTimeout(() => {
        setisPrintTable(false);
      }, 0);
    }
  }, [isPrintTable]);


  // Purchase Histroy Table - (Particular row print option)
  const handlePrintShow = (row) => {
    const RowData = row;
    const infoMessage = "Purchase History - Clicked Print button";
    const redirectURL = "---";
    const Response = JSON.stringify(RowData);
    const Status = "Print Purchase History to the Inmate ID - " + RowData?.InmateID;
    CreateEventLogTextFileForInbox(dispatch, infoMessage, redirectURL, Response, Status);
    setColumnOrderData(RowData); // Ensure RowData is set first
    setisPrintData(true);
    // if (ColumnOrderdata.length > 0) {
    //   setisPrintData(true);
    //   setTimeout(() => {
    //     handlePrints();
    //     setisPrintData(false); // Reset state immediately after printing
    //   }, 5); // Adjusted timeout for handlePrints
    // }
  };





  useEffect(() => {
    if (ColumnOrderdata && Object.keys(ColumnOrderdata).length > 0 && isPrintData) {
      setTimeout(() => {
        handlePrints();
        setisPrintData(false); // Reset state immediately after printing
      }, 0);
    }
  }, [ColumnOrderdata, isPrintData]);

  // -- Print Function with Page Size Set --// (Purchase History entire table print)
  const handlePrintsTable = useReactToPrint({
    pageStyle: `
      @media print {
        @page {
          margin: 5mm; /* Flexible margins */
        }
        body {
          margin: 0;
          padding: 0;
        }
        .print-content {
          margin-top: 5mm;
        }
      }
    `,
    content: () => componentPrintTableRef.current,
    onBeforeGetContent: () => { },
  });


  // -- Print Function with Page Size Set --// (Purchase history particular row print)
  const handlePrints = useReactToPrint({
    pageStyle: `
      @media print {
        @page {
          margin: 5mm; /* Keep margins flexible */
        }
        body {
          margin: 0;
          padding: 0;
        }
        .print-content {
          margin-top: 5mm;
        }
      }
    `,
    content: () => componentRef.current,
    onBeforeGetContent: () => { },
  });


  useEffect(() => {
    let inmatesID = 0;
    let userID = UserId;
    let ActiveStatus = 0;
    let SortField = "";
    let InmateLoadPurpose = "Photo";
    dispatch(
      myContactsActions.LoadPublicMyContactsDisplay({
        userID,
        inmatesID,
        InmateLoadPurpose,
        ActiveStatus,
        SortField,
      })
    );
    //  dispatch(subCategoryActions.getSubCategoryAll());
  }, [dispatch]);

  // Function for generate and download PDF
  const handleClickPDF = () => {
    let title = "Purchase History";
    const columnStyles = {
      CreditAmount: { halign: "left", cellWidth: 40 },
      Purpose: { halign: "left", cellWidth: 40 },
      TransactionDate: { halign: "center", cellWidth: 40 },
    };

    if (purchaseHistoryPopup?.printOption !== "2") {
      generatePDF(LoadCreditDebitTransactionDetails, columnStyles, true, title);
      const infoMessage = "Purchase History popup - All option - Clicked Download button";
      const redirectURL = "---";
      const Status = LoadCreditDebitTransactionDetails?.length > 0 ? "Download Purchase History to the Inmate ID - " + LoadCreditDebitTransactionDetails[0]?.InmateResidentId : "No data found";
      const Response = LoadCreditDebitTransactionDetails ? JSON.stringify(LoadCreditDebitTransactionDetails) : "No data found";
      EventLog(dispatch, infoMessage, redirectURL, Response, Status);
    } else {
      let data = purchaseHistoryPopup?.filterData;
      generatePDF(
        data,
        columnStyles,
        true,
        title,
        purchaseHistoryPopup.fromDate + " - " + purchaseHistoryPopup.toDate
      );
      const infoMessage = `Purchase History popup - Range option - Clicked Download button (${purchaseHistoryPopup.fromDate} to ${purchaseHistoryPopup.toDate})`;
      const redirectURL = "---";
      const Status = "Download Purchase History to the Inmate ID - " + data[0]?.InmateResidentId;
      const Response = data ? JSON.stringify(data) : "No data found";
      EventLog(dispatch, infoMessage, redirectURL, Response, Status);
      handlePurchaseHistoryClear();
    }
  };

  // Purchase history popup - Print Type (All/Range) onChange event
  const handleOptionChange = (e) => {
    const selectedOption = e.target.value;
    setPurchaseHistoryPopup((prevState) => ({
      ...prevState,
      printOption: selectedOption,
      fromDate: selectedOption === "2" ? prevState.fromDate : "", // Clear fromDate if not in range
      toDate: selectedOption === "2" ? prevState.toDate : "", // Clear toDate if not in range
    }));



    setPurchaseHistoryPopup((prevState) => ({
      ...prevState,
      fromDate: "",
      toDate: "",
      showLoadData: false,
      showMessage: false,
      filterData: [],
    }));
    setErrors({});
  };

  const handleDateBlur = (e, fieldName) => {
    let { value } = e.target;
    let isFromValid = true;
    let isToValid = true;

    if (fieldName === "fromDate") {
      if (purchaseHistoryPopup.toDate && new Date(value) > new Date(purchaseHistoryPopup.toDate)) {
        // Invalid: FromDate cannot be after ToDate
        isFromValid = false;
      }
    } else if (fieldName === "toDate") {
      if (purchaseHistoryPopup.fromDate && new Date(value) < new Date(purchaseHistoryPopup.fromDate)) {
        // Invalid: ToDate cannot be before FromDate
        isToValid = false;
      }
    }

    // Define date format used
    const minDate = new Date(1990, 0, 1);
    const today = new Date();
    const valueDate = new Date(value);
    const isValidDate = valueDate >= minDate && valueDate <= today;

    let updatedParam = {
      ...purchaseHistoryPopup,
      fromDate:
        fieldName === "fromDate"
          ? isFromValid && isValidDate
            ? value
            : ""
          : purchaseHistoryPopup.fromDate, // preserve existing value
      toDate:
        fieldName === "toDate"
          ? isToValid && isValidDate
            ? value
            : ""
          : purchaseHistoryPopup.toDate, // preserve existing value
    };
    setPurchaseHistoryPopup(updatedParam);
  };

  // Purchase History popup from date and To date onchange event
  const handleDateChange = (date, fieldName) => {
    // Format the date to MM/dd/yyyy
    const formattedDate = date
      ? new Intl.DateTimeFormat("en-US", {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
      }).format(date)
      : null;
    setPurchaseHistoryPopup({
      ...purchaseHistoryPopup,
      [fieldName]: formattedDate,
    });
  };

  // Function for purchase history popup filterData based on fromdate and todate and validation
  const handleFilterData = (e) => {
    e.preventDefault();
    setErrors({});
    const { error } = purchaseHistoryschema(purchaseHistoryPopup);
    if (error?.details) {
      error?.details?.map((e) => {
        const { path } = e;

        setErrors((prev) => ({
          ...prev,
          [e?.path[0]]: e?.message,
        }));
      });
      return;
    }

    const fromDate = new Date(purchaseHistoryPopup.fromDate);
    const toDate = new Date(purchaseHistoryPopup.toDate);

    toDate.setHours(23, 59, 59, 999);

    const filteredData = LoadCreditDebitTransactionDetails.filter(
      (transaction) => {
        const transactionDate = new Date(transaction.TransactionDate); // Convert TransactionDate to Date object
        return transactionDate >= fromDate && transactionDate <= toDate;
      }
    );
    const infoMessage = `Purchase History popup - Range option - Clicked Load Data button (${fromDate} to ${toDate})`;
    const Status = filteredData?.length > 0 ? "Load Data Purchase History to the Inmate ID - " + filteredData[0]?.InmateResidentId : "NO Data Found";
    const Response = filteredData?.length > 0 ? JSON.stringify(filteredData) : "No data found";
    const redirectURL = "---";
    EventLog(dispatch, infoMessage, redirectURL, Response, Status);
    setPurchaseHistoryPopup((prevState) => ({
      ...prevState,
      filterData: filteredData, // Store the filtered data
      showLoadData: filteredData.length > 0, // Check if there's data to load
      showMessage: filteredData.length === 0, // Show a message if no data found
    }));
  };

  // Clear purchase history popup data
  const handlePurchaseHistoryClear = () => {
    setPurchaseHistoryPopup({
      printOption: "2",
      fromDate: "",
      toDate: "",
      showLoadData: false,
      showMessage: false,
      filterData: [],
    });
    const infoMessage = "Purchase History popup - Clicked Clear button";
    const Status = "Clear Data Purchase History to the Inmate ID - " + getStoredValue("PurchaseHistoryInmateID");
    const Response = "Clear data";
    const redirectURL = "---";
    EventLog(dispatch, infoMessage, redirectURL, Response, Status);
    setErrors({});
  };

  const handleOpenModal = () => {
    setPrintOption({
      PublicUserName: "",
      InmateFullName: "",
      InmateID: "",
      date: "",
      tableData: [],
    });

    setPurchaseHistoryPopup({
      printOption: "1", // Reset to default print option
      fromDate: "",
      toDate: "",
      showLoadData: false,
      showMessage: false,
      filterData: [],
    });
    const infoMessage = "Purchase History - Clicked Print / Download button";
    const Response = "Purchase History popup to Shows the option ";
    const redirectURL = "---";
    const Status = "---";
    EventLog(dispatch, infoMessage, Response, Status, redirectURL);
    setisPrintTable(false); // Reset print state
  };


  // Purchase History popup cancel button event
  const handleCancelClick = () => {
    setPurchaseHistoryPopup({
      printOption: "1",
      fromDate: "",
      toDate: "",
      showLoadData: false,
      showMessage: false,
      filterData: [],
    });
    const infoMessage = "Purchase History popup - Clicked Cancel button";
    const Response = "Clear data";
    const Status = "Close the Print / Download popup Purchase History to the Inmate ID - " + getStoredValue("PurchaseHistoryInmateID");
    const redirectURL = "---";
    EventLog(dispatch, infoMessage, redirectURL, Response, Status);
  };

  return (
    <div className="">
      <div className="d-flex justify-content-between align-items-center">
        <div className="header-title">
          <h5>
            {currentLang?.PurchaseHistory}
          </h5>
        </div>
        <button
          type="button"
          onClick={handleChanges}
          className="btn btn-danger me-1 mb-3"
        >
          <i class="fa-solid fa-arrow-left me-1"></i>
          {currentLang?.buttons?.Back}
        </button>

      </div>
      <div className="">
        <div className="h-100 d-flex justify-content-center align-items-center">
          <div className="card w-100 border-radius-all shadow-sm mb-5">
            <div className="card-body p-2">
              <Panel>
                {/* <PanelHeader>
                   
                </PanelHeader> */}
                <div className="d-flex flex-wrap align-item-center pt-1 justify-right ms-4">
                  <h4 className="mb-0 fw-300">
                    {" "}
                    {currentLang?.Mycontacts?.Inmate_Name}  {" "}
                    <span className="text-default-red fw-700">{InmateName}</span>
                  </h4>

                  <div
                    className="d-flex flex-wrap pt-3 "
                    style={{ justifyContent: "end" }}
                  >
                    {IsHasData && (<button
                      type="button"
                      data-bs-toggle="modal"
                      data-bs-target="#modalDialog"
                      className="btn btn-success me-1 mb-1"
                      onClick={handleOpenModal}
                    >
                      <i class="fa-solid fa-print me-1"></i>
                      {currentLang?.Mycontacts?.Print_Download}
                    </button>)}

                    {/* <button type="button" data-bs-toggle="modal" data-bs-target="#modalDialog" className="btn btn-green me-1 mb-1">Cancel Request</button>
                    <button type="button" onClick={PurchaseCreditshandlechanges} className="btn btn-warning me-1 mb-1">Purchase Credit</button>  */}
                  </div>
                </div>

                <PanelBody>
                  <div className="card-body">
                    <TableForPurchaseHistory
                      columns={columns}
                      data={transformedData}
                      showSearch={true}
                      isloading={isloading}
                    />
                  </div>
                </PanelBody>
              </Panel>

              <div className="modal fade" id="modalDialog">
                <div className="modal-dialog modal-md-custom">
                  <div className="modal-content">
                    <div className="modal-header">
                      <h4 className="modal-title">{currentLang?.Mycontacts?.Purchase_History}</h4>
                      <button
                        type="button"
                        className="btn-close"
                        data-bs-dismiss="modal"
                        aria-hidden="true"
                      ></button>
                    </div>
                    <div className="modal-body">
                      <div className="row">
                        <div className="d-flex align-items-center gap-4">
                          <h5>{currentLang?.Mycontacts?.Type}</h5>
                          <div className="form-check form-check-inline">
                            <input
                              className="form-check-input"
                              type="radio"
                              id="inlineRadio1"
                              name="inlineRadio"
                              value="1"
                              checked={purchaseHistoryPopup.printOption === "1"}
                              onChange={handleOptionChange}
                            />
                            <label
                              className="form-check-label"
                              htmlFor="inlineRadio1"
                            >
                              <b>{currentLang?.Mycontacts?.ALL}</b>
                            </label>
                          </div>
                          <div className="form-check form-check-inline">
                            <input
                              className="form-check-input"
                              type="radio"
                              id="customRadio2"
                              name="inlineRadio"
                              value="2"
                              checked={purchaseHistoryPopup.printOption === "2"}
                              onChange={handleOptionChange}
                            />
                            <label
                              className="form-check-label"
                              htmlFor="customRadio2"
                            >
                              <b>{currentLang?.Mycontacts?.Range}</b>
                            </label>
                          </div>
                        </div>
                      </div>

                      {/* Conditional Rendering for Date Inputs */}
                      {purchaseHistoryPopup.printOption === "2" && (
                        <div>
                          <div className="row">
                            <div className="col-md-6 pt-3">
                              <DatePickerComponent
                                value={purchaseHistoryPopup.fromDate}
                                onChange={(e) =>
                                  handleDateChange(e, "fromDate")
                                }
                                name="fromDate"
                                onBlur={(e) => handleDateBlur(e, "fromDate")}
                                label={currentLang?.labels?.FromDate}
                                required={true}
                                disabled={purchaseHistoryPopup.showLoadData}
                                yearDropDown={true}
                                monthDropDown={true}
                                showTimeSelect={false}
                                minDate={new Date(1990, 0, 1)}
                                maxDate={purchaseHistoryPopup.toDate || new Date()}
                                clearOption={!purchaseHistoryPopup.showLoadData}
                              />
                              {errors.fromDate && (
                                <span className="text-danger">
                                  {errors.fromDate}
                                </span>
                              )}
                            </div>
                            <div className="col-md-6 pt-3">
                              <DatePickerComponent
                                value={purchaseHistoryPopup.toDate}
                                onChange={(e) =>
                                  handleDateChange(e, "toDate")
                                }
                                name="toDate"
                                onBlur={(e) => handleDateBlur(e, "toDate")}
                                label={currentLang?.labels?.ToDate}
                                minDate={purchaseHistoryPopup.fromDate || new Date(1990, 0, 1)}
                                maxDate={new Date()}
                                required={true}
                                disabled={purchaseHistoryPopup.showLoadData}
                                yearDropDown={true}
                                monthDropDown={true}
                                showTimeSelect={false}
                                clearOption={!purchaseHistoryPopup.showLoadData}
                              />
                              {errors.toDate && (
                                <span className="text-danger">
                                  {errors.toDate}
                                </span>
                              )}
                            </div>
                          </div>
                          <div className="row">
                            <div className="col d-flex justify-content-end gap-3 pt-3">
                              {/* Condition to show the Load Data button */}

                              {purchaseHistoryPopup?.showLoadData === false && (
                                <button
                                  className="btn btn-success text-start"
                                  onClick={handleFilterData}
                                // data-bs-dismiss="modal"
                                >
                                  {currentLang?.buttons?.Load_Data}
                                </button>
                              )}
                              {/* Condition to show success message if data is loaded */}
                              {purchaseHistoryPopup?.showLoadData === true &&
                                purchaseHistoryPopup?.showMessage === false && (
                                  <div className="text-default-success font-size-14">
                                    {currentLang?.Mycontacts?.Data_Load_Success}
                                  </div>
                                )}

                              {/* Clear Button */}
                              <button
                                className="btn btn-grey"
                                //  data-bs-dismiss="modal"
                                onClick={handlePurchaseHistoryClear}
                              >
                                {currentLang?.buttons?.Clear}
                              </button>
                            </div>
                          </div>
                        </div>
                      )}
                    </div>

                    <div className="modal-footer">
                      {/* Define buttons for Print and Download */}
                      {(purchaseHistoryPopup.printOption === "1" ||
                        (purchaseHistoryPopup.printOption === "2" &&
                          purchaseHistoryPopup?.filterData?.length > 0)) && (
                          <>
                            <button
                              className="btn btn-blue"
                              onClick={handlePrintTable}
                              data-bs-dismiss="modal"
                            >
                              {currentLang?.buttons?.Print}
                            </button>
                            <button
                              className="btn btn-success"
                              //data-bs-dismiss="modal"
                              onClick={handleClickPDF}
                            >
                              {currentLang?.buttons?.Download}
                            </button>
                          </>
                        )}

                      {purchaseHistoryPopup?.showMessage === true && (
                        <div className="text-danger fw-700 font-size-14 position-absolute-model" >{currentLang?.NO_Data_Found}</div>
                      )}

                      <button
                        className="btn btn-danger"
                        data-bs-dismiss="modal"
                        onClick={handleCancelClick}
                      >
                        {currentLang?.buttons?.Cancel}
                      </button>
                    </div>
                  </div>
                </div>
              </div>

              {/* ------------------For Print - Particular Row--------------------- */}
              {isPrintData && (
                <div style={{ position: 'absolute', left: '-9999px' }}>
                  <form ref={componentRef}>
                    <div className="container-fluid">
                      <div className="w-100">

                        {/* Date and Time on the Left */}
                        <div className="d-flex justify-content-start mb-2">
                          <p className="mb-0">{new Date().toLocaleString()}</p>
                        </div>
                        <div className="p-5 font-size-18">
                          {/* <h4 className="text-center font-size-20 mb-3">PURCHASE HISTORY</h4> */}
                          <div className="table-border">
                            <table className="table table-striped table-bordered">
                              <thead>
                                <tr>
                                  <th colSpan="2" style={{ textAlign: 'center', fontWeight: '700', fontSize: '20px' }}>{currentLang?.Mycontacts?.Purchase_History}</th>
                                </tr>
                              </thead>
                              <tbody>
                                {ColumnOrderdata.POTransactionRandomID !== "-" && ColumnOrderdata.POTransactionRandomID !== "" && <tr>
                                  <td className="fw-700">{currentLang?.labels?.Transaction_ID}</td>

                                  <td className="">
                                    {ColumnOrderdata.POTransactionRandomID}
                                  </td>
                                </tr>}
                                <tr>
                                  <td className="fw-700">{currentLang?.labels?.User_First_Name}</td>

                                  <td className="">
                                    {ColumnOrderdata?.PublicUserName
                                      ? ColumnOrderdata.PublicUserName.split(' ')[1]
                                      : ''}
                                  </td>
                                </tr>
                                <tr>
                                  <td className="fw-700">{currentLang?.labels?.User_Last_Name}</td>
                                  <td className="">
                                    {ColumnOrderdata?.PublicUserName
                                      ? ColumnOrderdata.PublicUserName.split(' ')[0]
                                      : ''}
                                  </td>
                                </tr>
                                <tr>
                                  <td className="fw-700">{currentLang?.labels?.Inmate_First_Name}</td>
                                  <td className="">
                                    {ColumnOrderdata?.InmateFullName
                                      ? ColumnOrderdata.InmateFullName.split(' ')[1]
                                      : ''}
                                  </td>
                                </tr>
                                <tr>
                                  <td className="fw-700">{currentLang?.labels?.Inmate_Last_Name}</td>
                                  <td className="">
                                    {ColumnOrderdata?.InmateFullName
                                      ? ColumnOrderdata.InmateFullName.split(' ')[0]
                                      : ''}
                                  </td>
                                </tr>
                                <tr>
                                  <td className="fw-700">{currentLang?.labels?.Inmate_Resident_ID}</td>
                                  <td className="">
                                    {ColumnOrderdata?.InmateResidentId}
                                  </td>
                                </tr>
                                <tr>
                                  <td className="fw-700">{currentLang?.labels?.Transaction_Purpose}</td>
                                  <td className="">
                                    {ColumnOrderdata?.TransactionPurpose}
                                  </td>
                                </tr>
                                <tr>
                                  <td className="fw-700">{currentLang?.labels?.Transaction_Date}</td>
                                  <td className="">
                                    {" "}
                                    {ColumnOrderdata?.TransactionDate}
                                  </td>
                                </tr>
                                {ColumnOrderdata?.CreditAmount !== 0 && ColumnOrderdata?.CreditAmount !== "0.00" && (
                                  <tr>
                                    <td className="fw-700">{currentLang?.labels?.Credit_Amount}</td>
                                    <td className="">${parseFloat(ColumnOrderdata.CreditAmount).toFixed(2)}</td>
                                  </tr>
                                )}
                                {ColumnOrderdata?.DebitAmount !== 0 && ColumnOrderdata?.DebitAmount !== "0.00" && (
                                  <tr>
                                    <td className="fw-700">{currentLang?.labels?.Debit_Amount}</td>
                                    <td className="">${parseFloat(ColumnOrderdata.DebitAmount).toFixed(2)}</td>
                                  </tr>
                                )}
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    </div>


                  </form>
                </div>
              )}
              {/* ------------For Print - Entire Table---------------- */}

              {isPrintTable && (
                <div style={{ position: 'absolute', left: '-9999px' }}>
                  <form ref={componentPrintTableRef}>
                    <div className="container-fluid mt-3 p-3">
                      {/* Header Section */}
                      <div className="row">
                        <div className="col-12 text-end">
                          <p>{new Date().toLocaleString()}</p> {/* Date and Time */}
                        </div>
                      </div>
                      <div className="row">
                        <div className="col text-center mb-4">
                          <h5 className="font-size-24 ">{currentLang?.Mycontacts?.Purchase_History}</h5>
                        </div>
                      </div>

                      {/* User and Inmate Information */}
                      <div className="row">
                        <div className="col-6 font-size-18 mb-3">
                          {currentLang?.labels?.Name} <b>{printOption?.PublicUserName}</b>
                        </div>
                        <div className="col-6 font-size-18">
                          {currentLang?.labels?.Inmate_Name} <b>{printOption?.InmateFullName}</b>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-6 font-size-18 mb-3">
                          {currentLang?.labels?.Inmate_ID} <b>{printOption?.InmateID}</b>
                        </div>
                        {purchaseHistoryPopup?.printOption === "2" && (
                          <div className="col-6 font-size-18">
                            {currentLang?.labels?.Date} <b>{printOption?.date}</b>
                          </div>
                        )}
                      </div>

                      {/* Each Transaction in Separate Table */}
                      <div className="row mt-3">
                        <div className="col-12 font-size-18">
                          {printOption?.tableData.map((row, index) => (
                            <table
                              key={index}
                              className="table table-bordered mb-4"
                              style={{ tableLayout: "fixed" }}
                            >
                              <colgroup>
                                <col style={{ width: "30%" }} />
                                <col style={{ width: "70%" }} />
                              </colgroup>
                              <tbody>
                                {row?.POTransactionRandomID !== "-" && row?.POTransactionRandomID !== 0 &&
                                  <tr>
                                    <td>
                                      <b>
                                        {currentLang?.labels?.Transaction_ID}
                                      </b>
                                    </td>
                                    <td>
                                      <b>
                                        {row?.POTransactionRandomID}
                                      </b>
                                    </td>
                                  </tr>}
                                <tr>
                                  <td>
                                    <b>
                                      {row?.CreditAmount > 0
                                        ? currentLang?.labels?.Credit_Amount
                                        : currentLang?.labels?.Debit_Amount}
                                    </b>
                                  </td>
                                  <td>
                                    $
                                    {row?.CreditAmount > 0
                                      ? parseFloat(row?.CreditAmount).toFixed(2)
                                      : parseFloat(row?.DebitAmount).toFixed(2)}
                                  </td>
                                </tr>
                                <tr>
                                  <td>
                                    <b>{currentLang?.labels?.Purpose}</b>
                                  </td>
                                  <td>
                                    {" "}
                                    <b>{row?.TransactionPurpose}</b>
                                  </td>
                                </tr>
                                <tr>
                                  <td>
                                    <b>{currentLang?.labels?.Transaction_Date}</b>
                                  </td>
                                  <td>
                                    <b>{row?.TransactionDate}</b>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          ))}
                        </div>
                      </div>
                      {loader}
                      {/* Footer Section */}
                      <div className="row">
                        <div className="col text-start">
                          <p className="small">
                            {window.location.href}
                          </p>
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>

  );
};

export default React.memo(PurchaseHistory);
